import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlRemuneracao = '/service/contabilidade/remuneracaoRestService/'

class DetalhesRemuneracaoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultar(filtro) {
        let data = {
            referencia: filtro.referencia,
            orgao: filtro.orgao,
            cargo: filtro.cargo,
            vinculo: filtro.vinculo,
            funcionario: filtro.funcionario,
            setor: filtro.setor,
            ativo: filtro.ativo,
            matricula: filtro.matricula,
        }
        return this.conex.post(urlRemuneracao + 'recuperarDetalhesRemuneracao/', JSON.stringify(data))
    }

    consultarDetalhes(filtro) {
        let data = {
            referencia: filtro.referencia,
            matricula: filtro.matricula,
        }
        return this.conex.post(urlRemuneracao + 'recuperarRemuneracaoDeducaoTotaisRemuneracao/', JSON.stringify(data))
    }
}

export default DetalhesRemuneracaoService
